/* eslint-disable max-len */
import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'ui-cms-cd-contact-channels-footer',
  styleUrl: 'ui-cms-cd-contact-channels-footer.scss',
})
export class UiCmsCdContactBox {
  @Prop() contactUrl: string;

  @Prop() email: string;

  render() {
    return (
      <div itemScope itemType="http://schema.org/Organization">
        <div class="contactbox__item">
          <ui-icon class="contactbox__icon" icon="letter"></ui-icon>
          <p>
            Kontaktieren Sie uns bei Fragen per <strong>E-Mail</strong> unter{' '}
            <strong>
              <ui-link href={`mailto:${this.email}`} itemProp="email">
                {this.email}
              </ui-link>
            </strong>
          </p>
        </div>
        <div class="contactbox__item">
          <ui-icon class="contactbox__icon" icon="mobile-phone"></ui-icon>
          <p>
            Weitere <strong>Kontaktkanäle</strong> finden Sie auf unserer{' '}
            <ui-link href={this.contactUrl}>Ansprechpartnerübersicht</ui-link>
          </p>
        </div>
      </div>
    );
  }
}
